import { render } from "./CometChatDeleteMessageBubble.vue?vue&type=template&id=25a668c2"
import script from "./CometChatDeleteMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatDeleteMessageBubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__